import styled from 'styled-components';

export const Content = styled.div`
  border-radius: 14px;
  background: #161e23;
  border: 1px solid #3d4952;
  box-shadow: 0 18px 50px 0 rgba(0, 0, 0, 0.55);
  width: ${(props) => props.width ?? 'auto'};
  height: ${(props) => props.height ?? 'auto'};
`;
